/*
 * AccountPanel.jsx
 * Created by michaelbray on 10/3/17
 */

import React from 'react';
import PropTypes from 'prop-types';

import { isLoggedIn, getRecAccount } from '../../../helpers/securityHelper';

import AccountSignIn from './AccountSignIn';
import AccountSignOut from './AccountSignOut';
import CreateAccountModal from './createAccount/CreateAccountModal';
import SignInModal from './signIn/SignInModal';
import ResetPasswordModal from './resetPassword/ResetPasswordModal';
import CartWarningModal from '../cart/CartWarningModal';

const propTypes = {
    accountServiceEnabled: PropTypes.bool,
    cart: PropTypes.object,
    account: PropTypes.object,
    loginError: PropTypes.bool,
    mfaRequired: PropTypes.bool,
    lockout: PropTypes.bool,
    fetchCart: PropTypes.func,
    login: PropTypes.func,
    loggedIn: PropTypes.func,
    logout: PropTypes.func,
    showLoginModal: PropTypes.bool,
    clearShowLoginModal: PropTypes.func,
    extendTimer: PropTypes.func,
    isHero: PropTypes.bool
};

const defaultProps = {
    accountServiceEnabled: true,
    fetchCart: () => {},
    login: () => {},
    loggedIn: () => {},
    logout: () => {},
    extendTimer: () => {},
    isHero: false
};

export default class AccountPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            createModalOpen: false,
            signInModalOpen: false,
            resetModalOpen: false
        };

        this.toggleCreateModalOpen = this.toggleCreateModalOpen.bind(this);
        this.toggleSignInModalOpen = this.toggleSignInModalOpen.bind(this);
        this.toggleResetModalOpen = this.toggleResetModalOpen.bind(this);
        this.openLoginModal = this.openLoginModal.bind(this);
    }

    componentWillMount() {
        if (isLoggedIn()) {
            this.props.loggedIn(getRecAccount());
            this.props.fetchCart();
        }
        if (this.props.showLoginModal && !this.signInModalOpen) {
            this.openLoginModal();
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.showLoginModal && !this.props.showLoginModal && !this.signInModalOpen) {
            this.openLoginModal();
        }
    }

    openLoginModal(){
        this.setState({
            signInModalOpen: true
        }, () => {
            this.props.clearShowLoginModal();
        });
    }

    toggleCreateModalOpen() {
        this.setState({
            createModalOpen: !this.state.createModalOpen,
            signInModalOpen: false,
            resetModalOpen: false
        });
    }

    toggleSignInModalOpen() {
        this.setState({
            createModalOpen: false,
            signInModalOpen: !this.state.signInModalOpen,
            resetModalOpen: false
        });
    }

    toggleResetModalOpen() {
        this.setState({
            createModalOpen: false,
            signInModalOpen: false,
            resetModalOpen: !this.state.resetModalOpen
        });
    }

    render() {
        let signInOrOutComponent = (
            <AccountSignIn
                toggleCreateModalOpen={this.toggleCreateModalOpen}
                toggleSignInModalOpen={this.toggleSignInModalOpen} />
        );

        if (this.props.account) {
            signInOrOutComponent = (
                <AccountSignOut
                    account={this.props.account}
                    cart={this.props.cart}
                    logout={this.props.logout} />
            );
        }

        let warningModal = (
            <CartWarningModal
                sessionWarning={this.props.cart.showSessionWarning}
                expiration={this.props.cart.expiration}
                extendTimer={this.props.extendTimer}
                fetchCart={this.props.fetchCart} />
        );

        if (this.props.isHero || !this.props.cart.showTimer) {
            warningModal = null;
        }

        // We're using this boolean to set disabled={true/false} on form elements,
        // so let's coerce it so we can use it in that manner
        const disableAccountFeatures = !this.props.accountServiceEnabled;

        return (
            <div className="nav-account-panel">
                {signInOrOutComponent}
                <CreateAccountModal
                    disableAccountFeatures={disableAccountFeatures}
                    isOpen={this.state.createModalOpen}
                    closeModal={this.toggleCreateModalOpen}
                    signIn={this.toggleSignInModalOpen} />
                <SignInModal
                    disableAccountFeatures={disableAccountFeatures}
                    isOpen={this.state.signInModalOpen}
                    closeModal={this.toggleSignInModalOpen}
                    create={this.toggleCreateModalOpen}
                    reset={this.toggleResetModalOpen}
                    login={this.props.login}
                    account={this.props.account}
                    error={this.props.loginError}
                    lockout={this.props.lockout}
                    mfaRequired={this.props.mfaRequired} />
                <ResetPasswordModal
                    isOpen={this.state.resetModalOpen}
                    closeModal={this.toggleSignInModalOpen}
                    signIn={this.toggleSignInModalOpen} />
                {warningModal}
            </div>
        );
    }
}

AccountPanel.propTypes = propTypes;
AccountPanel.defaultProps = defaultProps;
